document.addEventListener('DOMContentLoaded', function() {

  const light = document.querySelector('.light');
  const led = document.querySelector('.led');
  const vacuum = document.querySelector('.vacuum');
  const bright = document.querySelector('.bright');
  const msg = document.querySelector('.msg-container');
  
  let value = 285;
  
  function detectMouseWheelDirection(e){
      let delta = null,
          direction = false;
      if ( !e ) { // if the event is not provided, we get it from the window object
          e = window.event;
      }
      if ( e.wheelDelta ) { // will work in most cases
          delta = e.wheelDelta / 60;
      } else if ( e.detail ) { // fallback for Firefox
          delta = -e.detail / 2;
      }
      if ( delta !== null ) {
          direction = delta > 0 ? 'up' : 'down';
      }
  
      return direction;
  }
  function handleMouseWheelDirection(direction){
      //console.log( direction ); // see the direction in the console
      if ( direction == 'down' ) {
          // do something, like show the next page
          thingsOn();
          if(value > -20) {msg.style.cssText = 'bottom: '+ (value-=10) +'%';}
      } else if ( direction == 'up' ) {
          // do something, like show the previous page
          thingsOff();
          if(value < 285) {msg.style.cssText = 'bottom: '+ (value+=10) +'%';}
      } else {
          // this means the direction of the mouse wheel could not be determined
      }
  }
  const el = document.querySelector('.content');
  el.onmousewheel = function(e) {
      handleMouseWheelDirection( detectMouseWheelDirection(e) );
      preventScroll(e);
  };
  if ( window.addEventListener ) {
      el.addEventListener( 'DOMMouseScroll', function(e) {
          handleMouseWheelDirection( detectMouseWheelDirection(e) );
      });
  }
  el.addEventListener( 'touchstart', function() {
      if(vacuum.classList.contains('roll-down')) {
          thingsOff();
      } else if(vacuum.classList.contains('roll-up')) {
          thingsOn();
      } else {
          thingsOn();
          msg.classList.add('scroll-text');
      }
  });
  msg.addEventListener('animationend', () => {
      msg.classList.remove('scroll-text');
      thingsOff();
      el.addEventListener( 'touchstart', function() {
          msg.classList.add('scroll-text');
      });
  });
  function preventScroll(e){
      e.preventDefault();
      e.stopPropagation();
  
      return false;
  }
  function thingsOn() {
      light.classList.add('show');
      led.classList.add('show');
      vacuum.classList.add('roll-down');
      light.classList.remove('hide');
      led.classList.remove('hide');
      vacuum.classList.remove('roll-up');
  }
  function thingsOff() {
      light.classList.remove('show');
      led.classList.remove('show');
      vacuum.classList.remove('roll-down');
      light.classList.add('hide');
      led.classList.add('hide');
      vacuum.classList.add('roll-up');
  }
  
}); //DOMContentLoaded